<script lang="ts">
  import classnames from "classnames"
  import { omit } from "$lib/utils/object"

  export let variant: "transparent" | "white" = "white"
  export let compact = false

  const attributes = omit($$restProps, "class")
</script>

<section class="{classnames('section-product', $$props.class)}" class:v-white="{variant === 'white'}" {...attributes}>
  {#if $$slots.header}
    <div class="header" class:compact>
      <slot name="header" />
    </div>
  {/if}
  <div class="content">
    {#if $$slots.indicators}
      <div class="indicators">
        <slot name="indicators" />
      </div>
    {/if}
    <slot />
  </div>
  {#if $$slots.footer}
    <div class="footer">
      <slot name="footer" />
    </div>
  {/if}
</section>

<style type="text/scss" lang="scss" scoped>
  .section-product {
    @apply -page-margin;
    @apply lg:mr-0;
    @apply page-margin;

    /* Avoid sudden interruption of the block with the grid gap */
    @screen lg {
      margin-right: calc(var(--page-grid-gap) * -1);
      padding-left: var(--page-margin);
      padding-right: var(--page-grid-gap);
    }

    &.v-white {
      @apply relative;
      @apply bg-white;

      &:before {
        content: "";
        @apply md:block;
        @apply md:bg-white;
        @apply md:absolute inset-y-0 left-0;

        @screen lg {
          width: calc((100vw - var(--page-current-width)) / 2 + var(--page-margin));
          margin-left: calc((100vw - var(--page-current-width)) * -0.5 - var(--page-margin));
        }
      }
    }
  }

  .header {
    &:not(.compact) {
      @apply mb-5 md:mb-14;
    }

    &.compact {
      @apply mb-4 md:mb-6;
    }
  }

  .indicators {
    @apply flex justify-end;
  }

  .footer {
    @apply mt-6;
    @apply text-right;
  }
</style>
